import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnidadesService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;
 
    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
 }

  obterDadosMarca(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  obterUnidadeMarca(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/restaurants/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  listaUsuarios(): Observable<any> {
    return this.http.get(`${this.BASEURL}/users/employees`, {
      headers: this.httpHeaders,
    });
  }

  excluirUnidade(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/restaurants/${id}`, {
      headers: this.httpHeaders,
    });
  }

  salvaUnidade(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/restaurants`, body, {
      headers: this.httpHeaders,
    });
  }

  obterMoedas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/currencies`, {
      headers: this.httpHeaders,
    });
  }

  uploadImages(image: string): Observable<any> {
    return this.http.post(`${this.BASEURL}/images`, {
      image
    }, {
      headers: this.httpHeaders,
    });
  }

  obterDadosUnidade(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/restaurants/${id}`, {
      headers: this.httpHeaders,
    });
  }

  obterMeiosPagamento(): Observable<any> {
    return this.http.get(`${this.BASEURL}/payment-methods`, {
      headers: this.httpHeaders,
    });
  }

  editarUnidade(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/restaurants/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  obterLogradouroCep(cep: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/addresses/cep/${cep}`, {
      headers: this.httpHeaders,
    });
  }
}
